import React from 'react';

import { Typography } from 'antd';


const NoCreditsMessage = ({
    creditsResetDate,
    redirectToUpgrade = () => null,
    creditsType = 'AI credits'
}) => {
    return (
        <>
            Not enough {`${creditsType}`} to complete this action. Your {`${creditsType}`} will reset on
            {` ${creditsResetDate}`} or{' '}
            <Typography.Link onClick={redirectToUpgrade}>upgrade</Typography.Link> your plan
            now for more credits.
        </>
    );
};

export default NoCreditsMessage;
